module.exports = __webpack_public_path__ + "static/img/juxin-wchat.736d06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/juxin-wchat.png
// module id = DNXW
// module chunks = 0